import React, { FormEvent } from 'react';
import { IOptnRegion, IState } from '@nkr/models/index';
import { IAddEditState } from './add-edit-state';
import { Checkbox, Col, ControlLabel, FormControl, FormGroup, Glyphicon, HelpBlock, Row } from 'react-bootstrap'
import { Controller, useFormContext } from 'react-hook-form';
import { IValidateAchRoutingNumberResponse } from '@nkr/store/index';

interface IProps {
    isOpo: boolean,
    stateList: IState[],
    optnRegionList: IOptnRegion[],
    validateAchRoutingNumber: (achRoutingNumber: string) => Promise<IValidateAchRoutingNumberResponse>
}

const OpoContent = (props: IProps) => {
    const { control, formState: { errors, isSubmitting } } = useFormContext<IAddEditState>();

    return (
        <>
            {props.isOpo == false && (
                <>
                    <Row className='form-group'>
                        <Col sm={2} componentClass={ControlLabel} className={errors.optnAlias == null ? null : 'text-danger'}>OPTN Alias</Col>
                        <Col sm={3} className={errors.optnAlias == null ? null : 'has-error'}>
                            <Controller
                                control={control}
                                name='optnAlias'
                                rules={{
                                    required: 'OPTN alias is required'
                                }}
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        value={value}
                                        onChange={onChange} />
                                )}
                            />

                            {errors.optnAlias != null && (
                                <HelpBlock>{errors.optnAlias.message}</HelpBlock>
                            )}
                        </Col>

                        <Col sm={2} componentClass={ControlLabel} className={errors.optnName == null ? null : 'text-danger'}>OPTN Name</Col>
                        <Col sm={5} className={errors.optnName == null ? null : 'has-error'}>
                            <Controller
                                control={control}
                                name='optnName'
                                rules={{
                                    required: 'OPTN name is required'
                                }}
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        value={value}
                                        onChange={onChange} />
                                )}
                            />

                            {errors.optnName != null && (
                                <HelpBlock>{errors.optnName.message}</HelpBlock>
                            )}
                        </Col>
                    </Row>


                    <Row className='form-group'>
                        <Col sm={2} componentClass={ControlLabel} className={errors.nkrAlias == null ? null : 'text-danger'}>NKR Alias</Col>
                        <Col sm={3} className={errors.nkrAlias == null ? null : 'has-error'}>
                            <Controller
                                control={control}
                                name='nkrAlias'
                                rules={{
                                    required: 'NKR alias is required'
                                }}
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        value={value}
                                        onChange={onChange} />
                                )}
                            />

                            {errors.nkrAlias != null && (
                                <HelpBlock>{errors.nkrAlias.message}</HelpBlock>
                            )}
                        </Col>

                        <Col sm={2} componentClass={ControlLabel} className={errors.nkrName == null ? null : 'text-danger'}>NKR Name</Col>
                        <Col sm={5} className={errors.nkrName == null ? null : 'has-error'}>
                            <Controller
                                control={control}
                                name='nkrName'
                                rules={{
                                    required: 'NKR name is required'
                                }}
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        value={value}
                                        onChange={onChange} />
                                )}
                            />

                            {errors.nkrName != null && (
                                <HelpBlock>{errors.nkrName.message}</HelpBlock>
                            )}
                        </Col>
                    </Row>

                    <FormGroup validationState={errors.legalName != null ? 'error' : null}>
                        <Col sm={2} componentClass={ControlLabel}>Legal Name</Col>
                        <Col sm={10}>
                            <Controller
                                control={control}
                                name='legalName'
                                rules={{
                                    required: 'Legal name is required'
                                }}
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        value={value}
                                        onChange={onChange} />
                                )}
                            />

                            {errors.legalName != null && (
                                <HelpBlock>{errors.legalName.message}</HelpBlock>
                            )}
                        </Col>
                    </FormGroup>
                </>
            )}

            <FormGroup validationState={errors.address != null ? 'error' : null}>
                <Col sm={2} componentClass={ControlLabel}>Address</Col>
                <Col sm={10}>
                    <Controller
                        control={control}
                        name='address'
                        rules={{
                            required: 'Address is required'
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                value={value}
                                onChange={onChange} />
                        )}
                    />

                    {errors.address != null && (
                        <HelpBlock>{errors.address.message}</HelpBlock>
                    )}
                </Col>
            </FormGroup>

            <Row className='form-group'>
                <Col sm={2} componentClass={ControlLabel} className={errors.city == null ? null : 'text-danger'}>City</Col>
                <Col sm={3} style={{ width: '22%', paddingRight: 0 }} className={errors.city == null ? null : 'has-error'}>
                    <Controller
                        control={control}
                        name='city'
                        rules={{
                            required: 'City is required'
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                value={value}
                                onChange={onChange} />
                        )}
                    />

                    {errors.city != null && (
                        <HelpBlock>{errors.city.message}</HelpBlock>
                    )}
                </Col>

                <Col sm={1} componentClass={ControlLabel} style={{ paddingLeft: 5, paddingRight: 5 }} className={errors.stateId == null ? null : 'text-danger'}>State</Col>
                <Col sm={1} style={{ paddingLeft: 5, paddingRight: 5, width: '18%' }} className={errors.stateId == null ? null : 'has-error'}>
                    <Controller
                        control={control}
                        name='stateId'
                        rules={{
                            validate: (value) => {
                                if (value == 0) {
                                    return 'State is required'
                                }

                                return true;
                            }
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                componentClass='select'
                                value={value}
                                onChange={(e: FormEvent<FormControl & HTMLSelectElement>) => onChange(parseInt(e.currentTarget.value))}
                            >
                                <option value={0}>- Select -</option>
                                {props.stateList.map(state =>
                                    <option key={'st-' + state.id} value={state.id}>{state.description}</option>
                                )}
                            </FormControl>
                        )}
                    />

                    {errors.stateId != null && (
                        <HelpBlock>{errors.stateId.message}</HelpBlock>
                    )}
                </Col>

                <Col sm={2} componentClass={ControlLabel} style={{ paddingLeft: 5, paddingRight: 5, width: '13%' }} className={errors.postalCode == null ? null : 'text-danger'}>Postal Code</Col>
                <Col sm={3} style={{ paddingLeft: 5, paddingRight: 5, width: '21%' }} className={errors.postalCode == null ? null : 'has-error'}>
                    <Controller
                        control={control}
                        name='postalCode'
                        rules={{
                            required: 'Postal code is required'
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                value={value}
                                onChange={onChange} />
                        )} />

                    {errors.postalCode != null && (
                        <HelpBlock>{errors.postalCode.message}</HelpBlock>
                    )}
                </Col>
            </Row>

            <FormGroup validationState={errors.opoRegion != null ? 'error' : null}>
                <Col sm={2} componentClass={ControlLabel} className={errors.opoRegion == null ? null : 'text-danger'}>OPO Region</Col>
                <Col sm={10}>
                    <Controller
                        control={control}
                        name='opoRegion'
                        rules={{
                            validate: (value) => {
                                if (value == null || value == 0) {
                                    return 'OPO Region is required. Please select an OPO Region before saving.'
                                }

                                return true;
                            }
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                componentClass='select'
                                value={value}
                                style={errors.opoRegion == null ? null : { backgroundColor: '#fdeaea', borderColor: '#a94442' }}
                                onChange={(e: FormEvent<FormControl & HTMLSelectElement>) => onChange(parseInt(e.currentTarget.value))}
                            >
                                <option value={0}>- Select -</option>
                                {props.optnRegionList.map(region =>
                                    <option key={'st-' + region.id} value={region.id}>{region.regionNumber} - {region.states}</option>
                                )}
                            </FormControl>
                        )}
                    />

                    {errors.opoRegion != null && (
                        <HelpBlock style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <Glyphicon glyph='exclamation-sign' style={{ color: '#a94442', flexShrink: 0 }} />
                            {errors.opoRegion.message}
                        </HelpBlock>
                    )}
                </Col>
            </FormGroup>

            <Row className='form-group'>
                <Col sm={2} componentClass={ControlLabel} className={errors.executiveDirector == null ? null : 'text-danger'}>Executive Director</Col>
                <Col sm={3} className={errors.executiveDirector == null ? null : 'has-error'}>
                    <Controller
                        control={control}
                        name='executiveDirector'
                        rules={{
                            required: 'Executive director is required'
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                value={value}
                                onChange={onChange} />
                        )} />

                    {errors.executiveDirector != null && (
                        <HelpBlock>{errors.executiveDirector.message}</HelpBlock>
                    )}
                </Col>

                <Col sm={2} componentClass={ControlLabel} className={errors.medicalDirector == null ? null : 'text-danger'}>Medical Director</Col>
                <Col sm={5} className={errors.medicalDirector == null ? null : 'has-error'}>
                    <Controller
                        control={control}
                        name='medicalDirector'
                        rules={{
                            required: 'Medical director is required'
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                value={value}
                                onChange={onChange} />
                        )} />

                    {errors.medicalDirector != null && (
                        <HelpBlock>{errors.medicalDirector.message}</HelpBlock>
                    )}
                </Col>
            </Row>

            <Row className='form-group'>
                <Col sm={2} componentClass={ControlLabel} className={errors.phoneNumber == null ? null : 'text-danger'}>Phone Number</Col>
                <Col sm={3} className={errors.phoneNumber == null ? null : 'has-error'}>
                    <Controller
                        control={control}
                        name='phoneNumber'
                        rules={{
                            required: 'Phone number is required'
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                value={value}
                                onChange={onChange} />
                        )} />

                    {errors.phoneNumber != null && (
                        <HelpBlock>{errors.phoneNumber.message}</HelpBlock>
                    )}
                </Col>

                <Col sm={2} componentClass={ControlLabel} className={errors.website == null ? null : 'text-danger'}>Website</Col>
                <Col sm={5} className={errors.website == null ? null : 'has-error'}>
                    <Controller
                        control={control}
                        name='website'
                        rules={{
                            required: 'Website is required'
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                value={value}
                                onChange={onChange} />
                        )} />

                    {errors.website != null && (
                        <HelpBlock>{errors.website.message}</HelpBlock>
                    )}
                </Col>
            </Row>

            <FormGroup validationState={errors.achRoutingNumber != null ? 'error' : null}>
                <Col sm={2} componentClass={ControlLabel}>ABA Routing #</Col>
                <Col sm={10}>
                    <Controller
                        control={control}
                        name='achRoutingNumber'
                        rules={{
                            validate: async (value) => {
                                if (value == null) {
                                    return 'This is required'
                                }

                                if (isSubmitting) {
                                    let response = await props.validateAchRoutingNumber(value);

                                    if (response.data.success == false) {
                                        return 'Please specify a valid routing number';
                                    }
                                }

                                return true;
                            }
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                value={value}
                                onChange={onChange} />
                        )} />

                    {errors.achRoutingNumber != null && (
                        <HelpBlock>{errors.achRoutingNumber.message}</HelpBlock>
                    )}
                </Col>
            </FormGroup>

            <FormGroup validationState={errors.achAccountNumber != null ? 'error' : null}>
                <Col sm={2} componentClass={ControlLabel}>Account #</Col>
                <Col sm={10}>
                    <Controller
                        control={control}
                        name='achAccountNumber'
                        rules={{
                            required: 'This is required'
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl
                                value={value}
                                onChange={onChange} />
                        )} />

                    {errors.achAccountNumber != null && (
                        <HelpBlock>{errors.achAccountNumber.message}</HelpBlock>
                    )}
                </Col>
            </FormGroup>

            {props.isOpo == false && (
                <>
                <FormGroup validationState={errors.isActive != null ? 'error' : null}>
                    <Col sm={2} componentClass={ControlLabel}>ACH Approved</Col>
                    <Col sm={10}>
                        <Controller
                            control={control}
                            name='achApproved'
                            rules={{
                                validate: (value) => {
                                    if (value == null) {
                                        return 'This must be specified'
                                    }

                                    return true;
                                }
                            }}
                            render={({ field: { onChange, value } }) => (
                                <div>
                                    <Checkbox inline type='radio' name='achApproved' value={1} checked={value == true} onChange={() => onChange(true)}>Yes</Checkbox>
                                    <Checkbox inline type='radio' name='achApproved' value={0} checked={value == false} onChange={() => onChange(false)}>No</Checkbox>
                                </div>
                            )} />

                        {errors.achApproved != null && (
                            <HelpBlock>{errors.achApproved.message}</HelpBlock>
                        )}
                    </Col>
                </FormGroup>

                <FormGroup validationState={errors.isActive != null ? 'error' : null}>
                    <Col sm={2} componentClass={ControlLabel}>Active</Col>
                    <Col sm={10}>
                        <Controller
                            control={control}
                            name='isActive'
                            rules={{
                                validate: (value) => {
                                    if (value == null) {
                                        return 'Active must be specified'
                                    }

                                    return true;
                                }
                            }}
                            render={({ field: { onChange, value } }) => (
                                <div>
                                    <Checkbox inline type='radio' name='isActive' value={1} checked={value == true} onChange={() => onChange(true)}>Yes</Checkbox>
                                    <Checkbox inline type='radio' name='isActive' value={0} checked={value == false} onChange={() => onChange(false)}>No</Checkbox>
                                </div>
                            )} />

                        {errors.achAccountNumber != null && (
                            <HelpBlock>{errors.achAccountNumber.message}</HelpBlock>
                        )}
                    </Col>
                </FormGroup>
                </>
            )}
        </>
    );
}

export default OpoContent;